import { render, staticRenderFns } from "./SpeakToExpert.vue?vue&type=template&id=a6ec63c6&"
import script from "./SpeakToExpert.vue?vue&type=script&lang=js&"
export * from "./SpeakToExpert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports